// extracted by mini-css-extract-plugin
module.exports = {"container":"_2MI3z","vidBeingClosed":"_1eLht"};